// AutoLogout.js

import { useIdleTimer } from "react-idle-timer";
import { useAuth } from "./AuthContext";

export default function AutoLogout() {
  const { currentUser, logOut } = useAuth();

  useIdleTimer({
    // timeout: 30 * 60 * 1000, // 30 minutes d'inactivité
    timeout: 2 * 60 * 60 * 1000,
    onIdle: () => {
      if (currentUser) {
        logOut();
        console.log("Déconnexion automatique pour cause d'inactivité");
      }
    },
    debounce: 500,
  });

  return null;
}
